import React, { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";

export const GuestForm = ({ idx, updateGuest, formSubmitClicked }) => {
	const [name, _setName] = useState(""),
		[showWarningModal, setShowWarningModal] = useState(false);
	const setName = (val) => {
		_setName(val);
		updateGuest(idx, { name: name }, false);
	};
	const handleChange = (val) => {
		setName(val);
	};
	const removeGuest = () => {
		setName("");
		updateGuest(idx, { name: name }, true);
	};
	return (
		<div className="mt-2 ">
			<div
				className="position-relative d-flex align-items-stretch"
				style={{ gap: ".5rem" }}
			>
				<Form.Group controlId="guest_name" style={{ flexGrow: 1 }}>
					<Form.Control
						value={name}
						required
						onChange={(e) => {
							handleChange(e.target.value);
						}}
						onBlur={(e) => {
							handleChange(e.target.value);
						}}
						placeholder="Guest Name"
						className={"nf-sans-cond"}
					/>
				</Form.Group>

				{name || name === "" ? (
					<div style={{ display: "flex", alignItems: "stretch" }}>
						<Button
							className="rsvp-button "
							onClick={() => {
								setShowWarningModal(true);
							}}
						>
							Remove
						</Button>
					</div>
				) : null}
			</div>

			{formSubmitClicked && name === "" ? (
				<div className="validation__message mt-2">
					Please enter the guest's name
				</div>
			) : (
				""
			)}

			<Modal
				show={showWarningModal}
				onHide={() => {
					setShowWarningModal(false);
				}}
				size="lg"
				dialogClassName="event__modal-new eventmodal__container"
				centered={true}
			>
				<div
					style={{
						flexGrow: 1,
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
					}}
				>
					<div
						className="my-3 text-center text-uppercase font-weight-bold nf-sans-cond"
						style={{ fontSize: "1.5rem", color: "#fff" }}
					>
						Are you sure you want to remove this guest?
					</div>
					<div className="justify-content-center mb-2 d-flex">
						<Button
							className="rsvp-button white-button nf-sans-cond"
							onClick={(e) => {
								setShowWarningModal(false);
								removeGuest();
							}}
						>
							Yes
						</Button>
						<Button
							className="ms-2 rsvp-button white-button nf-sans-cond"
							onClick={(e) => {
								setShowWarningModal(false);
							}}
						>
							No
						</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
};
